var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92877 0C3.28922 0 0.338623 1.07556 0.338623 2.40298V4.37476C0.338623 5.70234 3.28922 6.77757 6.92877 6.77757C10.5681 6.77757 13.5187 5.70217 13.5187 4.37476V2.40298C13.5187 1.07556 10.5681 0 6.92877 0Z",
    fill: "#4E5FC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92883 7.92664C3.45399 7.92664 0.589193 6.94546 0.338683 5.70132C0.326738 5.76071 0.338683 8.95762 0.338683 8.95762C0.338683 10.2854 3.28928 11.3606 6.92883 11.3606C10.5682 11.3606 13.5188 10.285 13.5188 8.95762C13.5188 8.95762 13.5262 5.76055 13.5144 5.70132C13.2636 6.94563 10.4035 7.92664 6.92883 7.92664Z",
    fill: "#3B4793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5126 10.3407C13.2622 11.5842 10.4037 12.5659 6.92883 12.5659C3.45399 12.5659 0.588523 11.584 0.338013 10.3407L0.338686 13.5972C0.338686 14.9248 3.28929 16 6.92883 16C10.5682 16 13.5188 14.9244 13.5188 13.5972L13.5126 10.3407Z",
    fill: "#3B4793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.b720c4f8.svg";
export { ForwardRef as ReactComponent };